import axios from "axios";
import { BACKGROUND_TASK_STATUS } from "../../../../../constants/config";

export function getBackgroundJobs(params) {
  return axios.get(`${BACKGROUND_TASK_STATUS}`, { params });
}
